import React, { useState, useEffect } from "react";

const SwitchBtn = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    // localStorage.getItem("theme") === "dark" // Comprobamos si el usuario ya eligió el modo oscuro previamente
    localStorage.getItem('theme') !== 'light' // Inicializamos en modo oscuro si no se ha establecido en modo claro
  );

  const toggleTheme = () => {
    const newTheme = isDarkMode ? "light" : "dark";
    setIsDarkMode(!isDarkMode);
    localStorage.setItem("theme", newTheme); // Guardamos la preferencia del usuario en el almacenamiento local
  };

  useEffect(() => {
    // Cuando el componente se monta, comprobamos si el usuario ya eligió el modo oscuro previamente
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      setIsDarkMode(storedTheme === "dark");
    }
  }, []);


    useEffect(() => {
      // Cambia las variables CSS según el estado del tema
      document.documentElement.style.setProperty("--BGColor-Var", isDarkMode ? "#000000" : "#eeeeee" );
      document.documentElement.style.setProperty("--BarColor-Var", isDarkMode ? "#000000" : "#eeeeee" );
      document.documentElement.style.setProperty("--LogoWhiteColor-Var", isDarkMode ? "#ffffff" : "#1f212e" );
      document.documentElement.style.setProperty("--MainTextColor-Var", isDarkMode ? "#ffffff" : "#000000" );
      document.documentElement.style.setProperty("--BGMenu-Var", isDarkMode ? "#252935" : "#ffffff" );
      document.documentElement.style.setProperty("--IconYPos-Var", isDarkMode ? `${0}px` : `${-40}px` );
      document.documentElement.style.setProperty("--IconYPos-Var_L2", isDarkMode ? `${-80}px` : `${-120}px` );
      document.documentElement.style.setProperty("--BGAccordion-Var", isDarkMode ? "#2b3340" : "#ebebec" );
      document.documentElement.style.setProperty("--BorderColorAc-Var", isDarkMode ? "#3c4350" : "#dddddd" );
      document.documentElement.style.setProperty("--BGColorIcon-Var", isDarkMode ? "#23293b" : "#d6d6d6" );
      document.documentElement.style.setProperty("--BGTransColor-Var", isDarkMode ? "rgba(0, 0, 0,0.8)" : "rgba(235, 235, 235, 0.8)" );
      document.documentElement.style.setProperty("--BGTabsColor-Var", isDarkMode ? "#353a4d" : "#e4e2dc" );
      document.documentElement.style.setProperty("--BGBoxes-Var", isDarkMode ? "#000000" : "#ece9e0" );
      document.documentElement.style.setProperty("--Img_CDS-Var", isDarkMode ? "url('/images/cds_d_mode.svg')" : "url('/images/cds_l_mode.svg')" );
      document.documentElement.style.setProperty("--Img_RTG-Var", isDarkMode ? "url('/images/rtg-logo_d_mode.svg')" : "url('/images/rtg-logo_l_mode.svg')" );
      document.documentElement.style.setProperty("--BG_DepMet", isDarkMode ? "url('/images/dep-metods.svg')" : "url('/images/dep-metods-d.svg')" );
    }, [isDarkMode]);

  return (
    <div
      id="BtnSwitchTheme"
      className={`theme-switcher ${isDarkMode ? "" : "LightMode"}`}
      onClick={toggleTheme}
    >
      <div id="InsideBtn">{!isDarkMode ? "Light" : "Dark"}</div>
    </div>
  );
};
export default SwitchBtn;
